<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img"><img src="/assets/product/engine/4G15H/4G15H.jpg" alt=""></div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4G15H 1.5L自吸混动汽油发动机</div>
                <div class="detail-banner-desc">
                    4G15H发动机是为匹配混动车型专项设计的1.5L自吸高效混动汽油机，最大马力95匹，最低燃油消耗率220g/kW·h。
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">强动力</div>
        <div class="detail-desc">最大扭矩起始转速低、持续转速范围广，加速平顺、动力充足，提升行驶质感。</div>
        <div class="detail-utils">
            <div class="detail-utils-item">
                <div class="detail-utils-d">最大功率（6000r/min）</div>
                <div class="detail-utils-u">70kW</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">最大扭矩（4800r/min）</div>
                <div class="detail-utils-u">125N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">低速扭矩</div>
                <div class="detail-utils-u">1000r/min 90N·m，1200r/min 95N·m</div>
            </div>
            <div class="detail-utils-item">
                <div class="detail-utils-d">排放水平</div>
                <div class="detail-utils-u">国6b</div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4G15H/4G15H-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        高压缩比＋全新设计燃烧系统
                    </div>
                    <div class="detail-desc">
                        全新设计的发动机燃烧系统匹配高压缩比、阿特金森循环、高效点火技术等，提高发动机热效率，同时高效的燃烧系统，也同时提升了发动机的动力水平。
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">低油耗</div>
        <div class="detail-desc">发动机应用EGR废气在循环技术、电子水泵智能冷却技术等创新技术，采用多项减摩降损措施，使发动机燃烧更充分，油耗更低。</div>
        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15H/4G15H-2.jpg" alt=""></img>
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    EGR废气再循环技术
                </div>
                <div class="detail-four-desc">
                    降低部分负荷泵气损失，同时降低缸内燃烧温度，抑制爆震，极大降低了发动机油耗。
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">
                    智能冷却技术
                </div>
                <div class="detail-four-desc">
                    采用电子水泵实现冷却系统智能控制，自动识别发动机工况及所处阶段，实现冷却系统智能闭环控制，在中负荷通过提高目标水温，降低摩擦损失，进一步降低发动机油耗。
                </div>

            </div>
            <div class="detail-four-item">
                <div class="img-box">
                    <img src="/assets/product/engine/4G15H/4G15H-3.jpg" alt=""></img>
                </div>
            </div>
        </div>
    </div>


    <div class="detail-box">
        <div class="detail-title">NVH</div>
        <div class="detail-desc">发动机NVH声品质进行提升，对发动机零部件进行静音优化，使发动机声音更“美好”。</div>
        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4G15H/4G15H-4.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        塑料进气歧管
                    </div>
                    <div class="detail-desc">
                        进气歧管选用塑料材料，降低发动机噪声，进一步提升发动机NVH水平。
                    </div>
                </div>
            </div>
        </div>
    </div>



    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
    title: '4G15H 1.5L自吸混动汽油发动机 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'engine/4G15H.html'
};

import { createApp } from 'vue';
import App from './4G15H.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./4G15H.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>